// import type { LiveChat } from 'src/types/live'
// import { v4 as uuid } from 'uuid'
import type { StateCreator } from 'zustand'
import type { LiveBubbleMessage, LiveChat } from '../../types/lives/live'

// cap do histórico do chat: mantém só as últimas N msgs no DOM. Sem isso o chat
// crescia infinito (concat sem limite) e travava a live sob flood de gift/level.
const CHAT_MESSAGES_CAP = 60

interface State {
  chat: LiveChat[]
  bubbleMessages: LiveBubbleMessage[]
}

interface Actions {
  addMessageChatLive: (liveChat: LiveChat) => void
  clearChatLive: () => void
  clearNotificationsChatLive: () => void

  addBubbleMessageLive: (bubbleMessage: LiveBubbleMessage) => void
  removeBubbleMessageLive: (bubbleMessageId: string) => void
  clearBubbleMessage: () => void
}

export type ChatLiveSlice = State & Actions

export const chatLiveStore: StateCreator<
  ChatLiveSlice,
  [],
  [],
  ChatLiveSlice
> = (set) => ({
  chat: [],
  bubbleMessages: [],
  addMessageChatLive: (liveChat) => {
    set((prevState) => ({
      // mantém só as últimas N (descarta as antigas 1 a 1, sem solavanco)
      chat: (prevState?.chat ?? []).concat(liveChat).slice(-CHAT_MESSAGES_CAP),
    }))
  },
  clearChatLive: () => {
    set((prevState) => ({ chat: prevState.chat.slice(-CHAT_MESSAGES_CAP) }))
  },
  clearNotificationsChatLive: () => {
    set((prevState) => ({
      chat: prevState?.chat?.filter((message) => typeof message !== 'string'),
    }))
  },
  addBubbleMessageLive: (bubbleMessage) => {
    set((prevState) => ({
      bubbleMessages: prevState?.bubbleMessages?.concat({
        ...bubbleMessage,
        id: String(Date.now()),
      }),
    }))
  },
  removeBubbleMessageLive: (bubbleMessageId) => {
    set((prevState) => ({
      bubbleMessages: prevState?.bubbleMessages?.filter(
        (bubbleMessage) => bubbleMessage?.id !== bubbleMessageId,
      ),
    }))
  },
  clearBubbleMessage: () => {
    set({ chat: [] })
  },
})
